module.exports = tessa.common.utility;